import { createSlice } from "@reduxjs/toolkit";
import { GETUser } from "../../lib/token";
import { Imagesuploaded } from "./attachments";
import { toast } from "react-toastify";

const RightOffSlice = createSlice({
  name: "OffSlice",
  initialState: {
    data: null,
    row: null,
    action: "",
    loading: false,
    status: false,
    error: null,
  },
  reducers: {
    RightOffStart: (state) => {
      state.status = true;
      state.loading = true;
    },
    RightOffSuccess: (state, action) => {
      state.status = true;
      state.loading = false;
      state.data = action.payload;
    },
    RightOffCash: (state, action) => {
      state.row = action.payload;
      state.action = action.payload.action;
    },
    RightOffFailure: (state, action) => {
      state.status = false;
      state.loading = false;
      state.error = action.payload;
    },
    RightOffClear: (state, action) => {
      state.status = false;
      state.loading = false;
      state.row = null;
      state.data = null;
      state.error = null;
    },
  },
});

export const {
  RightOffStart,
  RightOffSuccess,
  RightOffFailure,
  RightOffClear,
  RightOffCash,
} = RightOffSlice.actions;

export const getUserData = (data) => async (dispatch) => {
  try {
    dispatch(RightOffStart());
    if (data?.cid) {
      const response = await GETUser(data, "singleuser");
      if (response?.status === 200) {
        dispatch(RightOffSuccess(response.data));
        const files =
          response?.data?.cashout?.attachments || response?.data?.attachments;
        dispatch(Imagesuploaded(files));
      }
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(RightOffFailure(errorMessage));
  }
};

export const getUserDataDeposits = (data) => async (dispatch) => {
  try {
    dispatch(RightOffStart());
    if (data?.uid) {
      const response = await GETUser(data, "singledeposit");
      if (response?.status === 200) {
        dispatch(RightOffSuccess(response.data));
        const files = response?.data?.deposits?.attachments;
        dispatch(Imagesuploaded(files));
      }
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(RightOffFailure(errorMessage));
  }
};

export default RightOffSlice.reducer;
